import React, {useState, useContext} from 'react';
import { Pane, Tablist, Tab, Card, LockIcon} from 'evergreen-ui';

import VendasContext from '../../../../context/VendasContext';

import TabImovel from './Tabs/BoletimDeVenda/Imovel';
import TabVendedores from './Tabs/BoletimDeVenda/Vendedores';
import TabCompradores from './Tabs/BoletimDeVenda/Compradores';
import TabComissao from './Tabs/BoletimDeVenda/Comissao';
import PagamentoComissao from './Tabs/BoletimDeVenda/PagamentoComissao';

export default function BoletimDeVenda(){
    const {
        //sideId, sideProcesso,
        //selectedIndexEnviados, setSelectedIndexEnviados,
        selectedIndexBoletimDeVenda, setSelectedIndexBoletimDeVenda,
        dadosReciboEnviado,
        showTabsBoletim
    } = useContext(VendasContext);

    
    const [tabsRascunho] = useState(['Imóvel', 'Vendedor', 'Comprador', 'Comissão', 'Pagamento da comissão']);

    const verificarTabs = async () => {
        if(dadosReciboEnviado.status_processo >= 1 && dadosReciboEnviado.status_processo <= 8){
            showTabsBoletim[1] = true;
            showTabsBoletim[2] = true;
            showTabsBoletim[3] = true;
            showTabsBoletim[4] = true;
        }
        else{
            if(dadosReciboEnviado.status_processo >= 18){
                showTabsBoletim[1] = true;
            }

            if(dadosReciboEnviado.status_processo >= 19){
                showTabsBoletim[2] = true;
            }

            if(dadosReciboEnviado.status_processo >= 20){
                showTabsBoletim[3] = true;
                showTabsBoletim[4] = true;
            }
        }
    }
    verificarTabs();

    return(
        <Pane>
            <Pane zIndex={1} flexShrink={0} elevation={0} backgroundColor="white">
                <Pane display="flex" padding={8}>
                    <Tablist>
                        {tabsRascunho.map((tabBoletim, index) => (
                            <Tab
                                key={tabBoletim}
                                isSelected={selectedIndexBoletimDeVenda === index}
                                onSelect={() => setSelectedIndexBoletimDeVenda(index)}
                                aria-controls={`panel-${index}`}
                                aria-selected={selectedIndexBoletimDeVenda === index ? true : false}
                                //className='tab-enable'
                                className={
                                    showTabsBoletim[index] === true ? 'tab-enable' : 'tab-disable'
                                }
                                style={selectedIndexBoletimDeVenda === index ? { boxShadow: '0 0 0 2px #d6e0ff' } : { boxShadow: 'none' }}
                            >
                                {tabBoletim} {showTabsBoletim[index] === true ? '' : <LockIcon size={12} marginLeft={10}/>}
                            </Tab>
                        ))}
                    </Tablist>
                </Pane>
            </Pane>
            <Pane flex="1" overflowY="scroll" background="tint1" padding={16}>
                {tabsRascunho.map((tabBoletim, index) => (
                    <Card
                        key={tabBoletim}
                        id={`panel-${tabBoletim}`}
                        role="tabpanel"
                        aria-labelledby={tabBoletim}
                        aria-hidden={index !== selectedIndexBoletimDeVenda}
                        display={index === selectedIndexBoletimDeVenda ? 'block' : 'none'}
                    >
                        {/*Id do processo - sideId*/}
                        {tabBoletim === 'Imóvel' && <TabImovel />}
                        {tabBoletim === 'Vendedor' && <TabVendedores />}
                        {tabBoletim === 'Comprador' && <TabCompradores />}
                        {tabBoletim === 'Comissão' && <TabComissao />}
                        {tabBoletim === 'Pagamento da comissão' && <PagamentoComissao />}
                    </Card>
                ))}
            </Pane>
        </Pane>
    )   
}